var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-good-table',{attrs:{"pagination-options":{
        enabled: true,
        perPage: 5,
        perPageDropdown: [5, 10],
    },"columns":_vm.columns,"rows":_vm.rows}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }